
import { computed, defineComponent, onMounted, provide, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import redpackAddress from '@/contract/redPacketAddress'
import * as rpc from '@/contract/rpc'
import { useRecaptcha } from './composables/recaptcha'
import { useStorage } from './composables/storage'

export default defineComponent({
  setup () {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const storage = useStorage()
    const recaptcha = useRecaptcha()

    const ready = ref(false)

    const isFxWallet = /FxWalletBrowser/.test(navigator.userAgent)

    const isNeedCaptcha = computed(() => {
      return ['CreateRedPack', 'ReceiveRedPack', 'MyRecords'].includes(route.name as string)
    })

    const chainId = computed(() => {
      return store.state.wallet.chainId as rpc.Chain
    })

    const keepAliveInclude = computed(() => store.state.keepAliveInclude)
    const keepAliveRoute = computed(() => store.state.keepAliveRoute)

    store.commit(
      'setKeepAliveRoute',
      router.options.routes
        .filter((ele) => ele.meta?.keepAlive)
        .map((ele) => ele.name)
    )

    store.commit('setKeepAliveInclude', keepAliveRoute.value)

    onMounted(async () => {
      if (!isFxWallet) {
        ready.value = true

        return
      }

      // init wallet
      await store.dispatch('wallet/init')

      ready.value = true

      // init redpack contract
      store.dispatch('contractRedpack/init', {
        address: redpackAddress[chainId.value],
        rpc: rpc.address[chainId.value]
      })

      storage.clearExpireRedpackInput()
    })

    provide('isFxWallet', isFxWallet)

    return {
      keepAliveInclude,
      ready,
      recaptcha,
      isNeedCaptcha
    }
  }
})
